// Role-driven shortcut buttons. Action list comes from
// /api/home/widget/quick-actions (no hardcoding in the component itself).
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import {
    Shield, Users, Key, DollarSign, Megaphone, Sparkles,
    Database, Upload, Layout, Settings, Folder, Images, ArrowUpRight,
} from "lucide-react";

const ICONS = {
    shield: Shield, users: Users, key: Key, dollar: DollarSign,
    megaphone: Megaphone, sparkles: Sparkles, database: Database,
    upload: Upload, layout: Layout, settings: Settings,
    folder: Folder, images: Images,
};

export default function QuickActionsWidget() {
    const [d, setD] = useState({ actions: [] });
    const navigate = useNavigate();
    useEffect(() => {
        api.get("/home/widget/quick-actions").then((r) => setD(r.data)).catch(() => setD({ actions: [] }));
    }, []);
    return (
        <div className="border border-border rounded-sm bg-card p-4" data-testid="home-widget-quick-actions">
            <div className="eyebrow text-[10px] mb-3">Quick actions</div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
                {d.actions.map((a) => {
                    const Icon = ICONS[a.icon_key] || Sparkles;
                    return (
                        <button key={a.label}
                            onClick={() => navigate(a.to)}
                            data-testid={`home-action-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="group flex items-center gap-2 px-3 py-2.5 border border-border rounded-sm text-sm hover:border-primary hover:bg-primary/5 transition-colors text-left">
                            <Icon className="h-4 w-4 text-muted-foreground group-hover:text-primary shrink-0" strokeWidth={1.5} />
                            <span className="flex-1 truncate">{a.label}</span>
                            {/* iter-121.113 · Hide the hover affordance on
                                mobile — it has no hover and the 14px +
                                gap was clipping longer labels like
                                "Operations" / "Subscription". */}
                            <ArrowUpRight className="hidden md:inline h-3.5 w-3.5 opacity-0 group-hover:opacity-100 text-primary transition-opacity shrink-0" />
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
